import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { User } from '@/features/iam/users/User'
import { Workspace } from '@/features/iam/workspaces/Workspace'
import type { UserTransactionReason } from '@/features/payouts/user-transaction-reason'
import type { TransactionType } from '@/features/payouts/transaction-type'
import type { TransactionSourceType } from '@/features/payouts/transaction-source-type'
import type { TransactionStatus } from '@/features/payouts/transaction-status'
import { observable } from 'mobx'
import { unixEpoch } from '@/utils/date-util'
import type { TransactionFlag } from '@/features/payouts/transaction-flag'
import type { TransactionFailureReason } from '@/features/payouts/transaction-failure-reason'

export type AdminTransactionProps = ModelProps<AdminTransaction>

/**
 * A payout transaction's details, from the admin perspective.
 */
export class AdminTransaction extends Model<AdminTransaction> {
  id = Id.none
  @observable accessor shortId = ''
  @observable accessor amount = 0
  @observable accessor createdAt = unixEpoch()
  @observable accessor type: TransactionType = 'Payment'
  @observable accessor recipient = User.none
  @observable accessor workspace = Workspace.none
  @observable accessor source: TransactionSourceType = 'Unknown'

  @observable accessor reason: UserTransactionReason | null = 'Unknown'
  @observable accessor memo: string | null = null

  @observable accessor jobId = Id.none

  @observable accessor flags: TransactionFlag[] = []

  @observable accessor status: TransactionStatus = 'Unknown'
  @observable accessor iteration = 1
  @observable accessor canceledAt: Date | null = null
  @observable accessor approvedAt: Date | null = null
  @observable accessor completedAt: Date | null = null

  @observable accessor approvedByUserId: Id | null = null
  @observable accessor payoutId: Id | null = null

  @observable accessor stripeTransferId: string | null = null
  @observable accessor stripeAccountId: string | null = null

  @observable accessor lastFailureReason: TransactionFailureReason | null = null
  @observable accessor lastFailureDescription: string | null = null
}
